import React from "react";
import styles from "../styles/leaders.module.css";

function Leaders(props) {
  const section = props.section;
  if (section === "squirrels") {
    return (
      <section className={styles.leaders}>
        <h2>Leaders</h2>
        <p>Our dedicated Squirrel leaders:</p>
        <ul>
            <li>🩹 Ian</li>
            <li>🧭 Vicky</li>
        </ul>
      </section>
    );
  } else if (section === "beavers") {
    return (
      <section className={styles.leaders}>
        <h2>Leaders</h2>
        <p>Our dedicated Beavers leaders:</p>
        <ul>
            <li>🧭 Lynn (Pumba)</li>
        </ul>
      </section>
    );
  } else if (section === "cubs") {
    return (
        <section className={styles.leaders}>
            <h2>Leaders</h2>
            <p>Our dedicated Cubs leaders:</p>
            <ul>
                <li>🧭 Dan</li>
            </ul>
        </section>
    );
  } else if (section === "scouts") {
    return (
      <section className={styles.leaders}>
        <h2>Leaders</h2>
        <p>Our dedicated Scouts leaders:</p>
        <ul>
          <li>🐺 Andy</li>
          <li>🪓 Ben</li>
          <li>🩹 Ian</li>
          <li>🔥 Ollie (Hawkeye)</li>
          <li>🪢 Sam (Youngblood)</li>
        </ul>
      </section>
    );
  } else {
    return (
        <h1>You should not be seeing this!</h1>
    );
  }
}

export default Leaders;
